import { memo } from 'react';

import { Grid, IconButton, Typography } from '@material-ui/core';

import { ArrowBackLong, CloseIcon, colors } from '../../../assets';
import { Button } from '../../button/Button';
import { useStyles } from './FullScreenDialogHeader.styles';
import { FullScreenDialogHeaderProps } from './FullScreenDialogHeader.types';

export const FullScreenDialogHeader = memo(
  ({
    backText,
    closeIcon,
    closeButton,
    showScrollToTop,
    hideCloseButton,
    classes,
    onScrollToTop,
    onClose,
    onCloseIconClick,
  }: FullScreenDialogHeaderProps) => {
    const styles = useStyles({ isShowScrollToTop: showScrollToTop });

    return (
      <div className={classes?.root}>
        <Grid container spacing={2} justifyContent="space-between" alignItems="center" wrap="nowrap">
          <Grid item>
            <Button buttonType="text" className={styles.backButton} onClick={showScrollToTop ? onScrollToTop : onClose}>
              <Grid container alignItems="center" spacing={1} wrap="nowrap">
                <Grid item className={styles.arrowBackContainer}>
                  <ArrowBackLong fontSize={18} />
                </Grid>

                <Grid item className={styles.backTextContainer}>
                  <Typography variant="button" className={styles.backText}>
                    {showScrollToTop ? 'Top' : backText ? backText : 'Back'}
                  </Typography>
                </Grid>
              </Grid>
            </Button>
          </Grid>

          {!!(closeButton || onClose || onCloseIconClick) && !hideCloseButton && (
            <Grid item>
              {closeButton ?? (
                <IconButton id="close-modal" className={styles.closeButton} onClick={onCloseIconClick ?? onClose}>
                  {closeIcon ?? <CloseIcon fontSize={19} color={colors.grey100} />}
                </IconButton>
              )}
            </Grid>
          )}
        </Grid>
      </div>
    );
  },
);

FullScreenDialogHeader.displayName = 'FullScreenDialogHeader';
